import { Button, Checkbox, Form, Modal } from 'antd'
import React from 'react'

const TinTucConfirmSendNotificaitonModal = ({
  visible,
  onConfirm,
  onCancel,
}) => {
  const [form] = Form.useForm()

  return (
    <Modal
      wrapClassName="custom-modal-wrapper"
      title="Cập nhật tin tức chung"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose>
      <p>Bạn có muốn cập nhật tin tức chung này không?</p>
      <Form form={form} onFinish={onConfirm}>
        <Form.Item
          name="is_notification_required"
          initialValue={true}
          valuePropName="checked">
          <Checkbox>Gửi thông báo</Checkbox>
        </Form.Item>

        <div className="custom-modal-footer">
          <Button
            type="default"
            onClick={() => onCancel()}
            htmlType="reset"
            className="custom-ant-button w-160">
            Hủy bỏ
          </Button>
          <Button
            htmlType={'submit'}
            type={'primary'}
            className="custom-ant-button w-160">
            Xác nhận
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

export default TinTucConfirmSendNotificaitonModal
